export enum Source {
  web = 'web',
  link = 'link',
}
